import React from 'react';
import styled from 'styled-components';
import {Ellipse} from '@ey/canvascoreservices';
import {lightColor} from '@ey/styled-theme';
import {labels, currentResource} from '../../utils/utils';
import {routesResources} from '../../utils/uiconstants';
import {useCurrentProject} from '../../utils/customHooks';
import {useHistory} from 'react-router-dom';

export const ProjectSelect = () => {
	const {projectName} = useCurrentProject();

	if (projectName) {
		document.title = `${projectName} | ${labels.title}`;
	} else {
		document.title = labels.title;
	}

	const {location} = useHistory();

	return projectName ? (
		<StyledSection className="StyledSectionProjectName">
			<section className="vertical__line" />
			<h1 className="project__name">
				<Ellipse content={projectName} noOfLines={1} tooltip={projectName} />
			</h1>
		</StyledSection>
	) : location.pathname.toLowerCase().includes(`/${routesResources.admin}`) ? (
		<StyledSection className="StyledSectionAdminNavLabel">
			<section className="vertical__line" />
			<h1 className="project__name">
				<Ellipse
					content={currentResource.adminLabels.adminPortal}
					noOfLines={1}
					tooltip={currentResource.adminLabels.adminPortal}
				/>
			</h1>
		</StyledSection>
	) : null;
};

export default ProjectSelect;

const StyledSection = styled.section`
	vertical-align: top;
	margin: 1rem 0;
	display: inline-flex;
	flex-flow: row;
	max-width: calc(100% - 50rem);
	.vertical__line {
		height: 47%;
		margin-top: 1.7rem;
		border-left: 0.1rem solid ${lightColor[`white`]};
	}
	.project__name {
		font-size: 2.4rem;
		margin: 1.5rem 4rem 0 1.2rem;
		font-weight: 300;
		color: ${lightColor[`white`]};
		line-height: 2.4rem;
		overflow: auto;
	}
`;
